import React, { useState } from "react";

/** Small centered popup used for the "Rules" button and round 4's "Hint" button — same modal shell, different content. */
export function InfoModal({ title, children, onClose }) {
  return (
    <div className="modak-modal-overlay" onClick={onClose}>
      <div className="modak-modal" onClick={(e) => e.stopPropagation()}>
        {title && <h4>{title}</h4>}
        {children}
        <button type="button" className="modak-modal-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}

/**
 * Header bar shared by all 5 rounds: time + skip on the left, rules (+ round
 * 4's hint) + score on the right. Rules opens automatically on mount, same
 * as the old PHP app's `$('#rules').modal('show')` on every round page load.
 */
export function RoundHeader({ time, score, rules, onSkip, extra }) {
  const [showRules, setShowRules] = useState(true);

  return (
    <div className="modak-round-header">
      <div className="modak-round-header-left">
        <span className="modak-pill">Time: {time}</span>
        <button type="button" className="modak-pill" onClick={onSkip}>
          SKIP
        </button>
      </div>
      <div className="modak-round-header-right">
        {extra}
        <button
          type="button"
          className="modak-pill modak-pill--icon"
          onClick={() => setShowRules(true)}
          aria-label="Rules"
          title="Rules"
        >
          ?
        </button>
        <span className="modak-pill">Score: {score}</span>
      </div>

      {showRules && (
        <InfoModal title="Rules" onClose={() => setShowRules(false)}>
          <ul className="modak-rules-list">
            {rules.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </InfoModal>
      )}
    </div>
  );
}
